import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_CAREER_PROFILE } from "../../common/URLs";

export const fetchCareerProfile = async () => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_CAREER_PROFILE}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,      },
    });

    if (!response.ok) { 
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};